<template>
    <div class="container nopadding">
        <div class="wrapper">
            <div class="header"><h1 class="f2"><b>{{this.locale.nome_locale}}</b></h1>
                <h3 v-if="this.service_point">{{this.service_point.traduzione.nome}}</h3>
            </div>

            <div class="content text-center bg-gray">
                <!-- ordini + prenotazioni tavoli -->
                <div class="row">
                    <div class="col-md-6 sezione" :class="{'col-md-12': !this.enable_reservations}">
                        <img :src="`/img/be/${this.targa}/menu.png`" class="img-fluid img-center"><br><br>
                        <p>{{$t('ristorante_consulta')}}</p>
                        <router-link :to="{name:'orders'}" class="btn btn-menu">
                            {{$t('ristorante_ordina_btn')}}
                        </router-link>
                    </div>
                    <div class="col-md-6 sezione" v-if="this.enable_reservations">
                        <img :src="`/img/be/${this.targa}/prenota.png`" class="img-fluid img-center"><br><br>
                        <p>{{$t('ristorante_prenota')}}</p>
                        <router-link :to="{name:'reservations.reserve'}" class="btn btn-menu" v-if="!this.locale.prenota_tavolo_external_url">
                            {{$t('ristorante_prenota_btn')}}
                        </router-link>
                        <a target="_blank" :href="`${this.locale.prenota_tavolo_external_url}`" class="btn btn-menu" v-if="this.locale.prenota_tavolo_external_url">{{$t('ristorante_prenota_btn')}}</a>
                    </div>
                </div>


                <div style="margin:20px 40px 0 40px; padding-bottom: 40px;"
                     v-if="this.userAuthenticated && this.enable_fidelity_card && this.fidelity_card_promozione && this.fidelity_card_promozione.promozione">
                    <div class="card " style="border-radius: 0">
                        <div class="card-body">
                            <h4 class="card-title color">
                                <router-link :to="{name:'fidelity'}" class="a3">
                                    <i class="fa fa-id-card"></i> Fidelity Card
                                </router-link>
                            </h4>
                            <div class="text-center">
                                <!-- questa è la riga che va messa se non ho ancora punti nella fidelity <span class="text-muted">
                                    Non hai ancora accumulato punti nella tua fidelity card.
                                    <br>Comincia adesso, fai un ordine per ricevere i nostri premi.</span> -->
                                <span class="text-muted">{{$t("fidelity_card_ad_home_c1")}}</span>
                                <h2 class="font-light m-b-0 color">
                                    <i class="ti-arrow-up text-success"></i>
                                    {{this.fidelity_card_promozione.punteggio_personale}} {{$t("punti")}}
                                </h2>
                            </div>
                            <p class="color mb-1">{{this.fidelity_card_percentage}}%</p>
                            <div class="progress">
                                <div class="progress-bar" role="progressbar"
                                     aria-valuenow="25"
                                     :style="{width: (this.fidelity_card_percentage)+'%' }"
                                     aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- BANNER PROMOZIONALI -->
            <!--<div class="content sezione border-bottom text-center">
                <p class="f2 color f1 text-uppercase">PROMOZIONI</p>
                <swiper
                  class="swiper d-flex align-self-start"
                  :modules="modules"
                  :slides-per-view="3"
                  :pagination="{ clickable: true }"
                  :loop="true"
              >
                    <swiper-slide class="slide slide-banner">
                      <div class="tipo">sconto</div>
                      <div class="sconto">- 20%</div>
                      <div class="sconto-descrizione">Usa il codice: <b>summer</b></div>
                    </swiper-slide>

                    <swiper-slide class="slide slide-banner">
                      <div class="tipo">novità</div>
                      <div class="novita-descrizione">Scopri subito i nuovissimi piatti dedicati all'estate! Li troverai tutti nella sezione dedicata, ti aspettiamo!</div>
                    </swiper-slide>

                    <swiper-slide class="slide slide-banner slide-banner-nofoto">
                      <div class="tipo">sconto</div>
                      <div class="sconto">- 20%</div>
                      <div class="sconto-descrizione">Usa il codice: <b>summer</b></div>
                    </swiper-slide>
                </swiper>
            </div>-->

            <div class="content sezione" v-if="(this.locale_photos.length) || this.getLocaleDescription()">
                <p class="f2 color f1 text-uppercase">{{$t('ristorante_presentiamo_titolo')}}...</p><br>
                <div class="row">
                    <div class="text-justify"
                         :class="{'col-md-6': this.locale_photos.length, 'col-md-12': !this.locale_photos.length}">
                        <p v-html="this.getLocaleDescription(295)"></p>
                        <router-link :to="{name:'presentation'}" class="btn btn-primary btn-sm mb-2">
                            {{$t('ristorante_continua_lettura_btn')}} »
                        </router-link>
                    </div>
                    <div class="col-md-6" v-if="this.locale_photos.length">
                        <img :src="this.locale_image" class="img-fluid">
                    </div>
                </div>
            </div>

            <hr>

            <div class="content sezione" v-if="this.news.length">
                <p class="f2 color f1 text-center text-uppercase">{{$t('ristorante_novita_titolo')}}</p><br>
                <div class="row" v-for="notice in this.news">
                    <div class="col-md-3">
                        <img :src="getNewsImage(notice)" class="img-fluid img-thumbnail img-center">
                    </div>
                    <div class="col-md-9">
                        <p class="gray"><i class="fa fa-calendar"></i>
                            <i>
                                {{moment(notice.created_at).locale(language).format('dddd DD MMMM YYYY')}}
                            </i>
                        </p>
                        <p>{{notice.traduzione.titolo}}<br/>{{displayNewsText(notice)}}</p>
                        <router-link class="btn btn-primary btn-sm"
                                     :to="{name: 'news.list'}">
                            {{$t('ristorante_novita-vedi_btn')}}
                        </router-link>
                    </div>
                </div>
            </div>

            <div class="content sezione bg-gray">
                <p class="f2 color f1 text-center text-uppercase">{{$t('ristorante_orario_titolo')}}</p><br>
                <table class="table table-bordered" style="max-width:350px; margin:0 auto;">
                    <tbody>
                    <tr v-for="(opening, i) in this.opening_hours"
                        :key="i">
                        <td width="70">
                            <b>
                                {{
                                    moment((i >= 6 ? 0 : (i + 1)), "d").locale(language)
                                        .format("ddd").toUpperCase()
                                }}
                            </b>
                        </td>
                        <td :width="opening.length > 1 ? 140:280" :class="{'red': opening[0] === 'chiuso'}">
                            {{opening[0] === 'chiuso' ? $t('chiuso') : opening[0]}}
                        </td>
                        <td v-if="opening.length > 1" width="140" :class="{'red': opening[1] === 'chiuso'}">
                            {{opening[1] === 'chiuso' ? $t('chiuso') : opening[1]}}
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br>

                <!-- CHIUSURE -->
                <div v-if="this.configurazione_chiusure.length">
                    <div class="f1 text-center red">{{$t('ristorante_chiusure_title')}}:</div>
                    <p class="text-center m-0" v-for="closure in this.configurazione_chiusure">
                        <span class="text-capitalize">{{$t('dal')}}</span>
                        {{moment(closure.dal_giorno).format("DD/MM/YYYY")}} {{$t('al')}}
                        {{moment(closure.al_giorno).format("DD/MM/YYYY")}} -
                        {{closure.traduzione_ll ? closure.traduzione_ll.messaggio : null}}
                    </p>
                </div>
            </div>
            <hr>

            <div class="content sezione">
                <p class="f2 color f1 text-center text-uppercase">{{$t('ristorante_contatti_titolo')}}</p><br>
                <p class="text-center"><b class="f4">{{this.locale.nome_locale}}</b><br>
                    {{this.locale.indirizzo}}, {{this.locale.civico}}<br>
                    {{this.locale.cap}} - {{this.locale.citta}} ({{this.locale.provincia}})<br>
                    <i class="fa fa-phone fa-flip-horizontal mr-1"></i>
                    <a :href="'tel:'+this.locale.telefono" class="a2">
                        {{this.locale.telefono}}
                    </a>
                    <span class="d-none d-md-inline"> - </span>
                    <br class="d-block d-md-none">
                    <i class="fa fa-envelope mr-1"></i>{{this.locale.email}}
                </p>
                <p class="text-center mb-0">{{this.locale.ragione_sociale}} - {{$t("piva")}} {{this.locale.piva}}</p>
            </div>

            <iframe v-if="this.locale.latitudine && this.locale.longitudine" class="w-100" height="200" frameborder="0"
                    scrolling="no" marginheight="0" marginwidth="0"
                    :src="`https://maps.google.com/maps?q=${this.locale_address}&t=&z=14&ie=UTF8&iwloc=&output=embed`"></iframe>
        </div>
    </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex';
import {getImage} from "../api/core";
import {getFidelityCard, getMixedInfo} from "../api/restaurant";

export default {
    data() {
        return {
            fidelity_card_promozione: null,
            configurazione_chiusure: [],
            news: [],
            info_locale: []
        }
    },
    created() {
        this.fetchInfo();
    },
    computed: {
        locale_photos: function () {
            if (this.info_locale && this.info_locale.foto) {
                return this.info_locale.foto;
            }

            return [];
        },
        locale_image: function () {
            try {
                const code = this.info_locale.foto[0].codice;

                return getImage(this.language, this.id_ristorante, code);
            } catch (e) {
                return null;
            }
        },
        fidelity_card_percentage: function () {
            try {
                return parseInt(this.fidelity_card_promozione.punteggio_personale / this.fidelity_card_promozione.punteggio_massimo * 100);
            } catch (e) {
                return 0;
            }
        },
        service_point: function () {
            if (this.f_modalita_fiera) {
                return this.punti_di_servizio.find((point) => {
                    return point.id === this.id_punto_di_servizio
                });
            }

            return null;
        },
        ...mapGetters('restaurant', {
            enable_reservations: 'enableReservations',
            enable_fidelity_card: 'enableFidelityCard',
            opening_hours: 'openingHours',
            locale_address: 'localeAddress',
            getLocaleImageCode: 'localeImageCode',
            getLocaleDescription: 'localeDescription',
        }),
        ...mapGetters('auth', {
            userAuthenticated: 'authenticated'
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            targa: state => state.targa,
            locale: state => state.locale,
            id_ristorante: state => state.id,
            punti_di_servizio: state => state.punti_di_servizio,
            f_modalita_fiera: state => state.f_modalita_fiera
        }),
        ...mapState('auth', {
            user: state => state
        }),
        ...mapState('global', {
            loading_visible: state => state.loading_visible
        }),
        ...mapState('order', {
            id_punto_di_servizio: state => state.id_punto_di_servizio
        })
    },
    watch: {
        language: function () {
            this.fetchInfo();
        },
        userAuthenticated: function () {
            this.fetchInfo();
        }
    },
    methods: {
        fetchInfo: function () {
            this.showLoading(true);
            axios.all([
                getMixedInfo(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    configurazione_chiusure: true,
                    news: true,
                    news_limit: 1,
                    info_locale: true
                }),
                getFidelityCard(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    email: this.user.email,
                    api_key: this.user.api_key
                })
            ]).then(axios.spread((...responses) => {
                // use/access the results
                const responseMixed = responses[0];
                const responseFidelity = responses[1];

                this.configurazione_chiusure = responseMixed.configurazione_chiusure;
                this.news = responseMixed.news;
                this.info_locale = responseMixed.info_locale;
                this.fidelity_card_promozione = responseFidelity;

            })).catch(messages => {
                // react on errors.
                alert(messages.join("\n"));
            }).finally(() => {
                if (this.loading_visible) {
                    this.showLoading(false);
                }
            });
        },
        getNewsImage: function (news) {
            return getImage(this.language, this.id_ristorante, news.foto_codice);
        },
        displayNewsText: function (news) {
            return news.traduzione.testo > 200 ?
                news.traduzione.testo.substr(0, 200) + ' ... ' : news.traduzione.testo
        },
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>